import { ReactNode } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid2,
  useMediaQuery,
  useTheme
} from "@mui/material";
import {
  MRT_EditActionButtons as MRTEditActionButtons,
  MRT_Row,
  MRT_TableInstance
} from "material-react-table";
import {
  isConferenceVisitorRegistrationRow,
  type VisitorBookingTableRow
} from "./visitor-bookings-table.partial";
import { TransitionForSlideoutPanel } from "../../../components/SlideoutPanel/SlideoutPanelTransition.component";

export function VisitorBookingsSlidePanelEditRow({
  table,
  row,
  internalEditComponents,
  headline
}: Readonly<{
  table: MRT_TableInstance<VisitorBookingTableRow>;
  row: MRT_Row<VisitorBookingTableRow>;
  internalEditComponents: ReactNode[];
  headline: string;
}>) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isConference = isConferenceVisitorRegistrationRow(row.original);

  const editDialogStyle = {
    height: "calc(-64px + 100vh)",
    maxHeight: "calc(-64px + 100vh)",
    maxWidth: isMobile ? "inherit" : "50vw",
    position: "absolute",
    right: 0,
    margin: 0,
    width: isMobile ? "100%" : "40vw",
    padding: 3,
    top: "64px"
  };

  return (
    <Dialog
      open
      data-testid="visitor-bookings-edit-row-dialog"
      slotProps={{ paper: { sx: { ...editDialogStyle } } }}
      transitionDuration={400}
      slots={{ transition: TransitionForSlideoutPanel }}
    >
      <DialogTitle variant="h4">{headline}</DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: "1.5rem", mt: 2 }}>
        <Grid2 container data-testid="visitor-bookings-edit-dialog-contents" columnGap={4}>
          <Grid2 container size={{ xs: 12 }} rowGap={3.5}>
            {/* name */}
            {internalEditComponents[1]}
            {/* company */}
            {internalEditComponents[2]}
            {/* email */}
            {internalEditComponents[3]}
            {/* contacts */}
            {internalEditComponents[4]}
            {!isConference && internalEditComponents[5]}
            {!isConference && internalEditComponents[6]}
            {!isConference && internalEditComponents[7]}
            {/* visit reason */}
            {internalEditComponents[8]}
            {/* location */}
            {internalEditComponents[10]}
          </Grid2>
        </Grid2>
      </DialogContent>
      <Divider sx={{ mt: 3, mb: 3, opacity: "0.6" }} />
      <DialogActions>
        <MRTEditActionButtons variant="text" table={table} row={row} />
      </DialogActions>
    </Dialog>
  );
}
